var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTalenticaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 213.3 70.7",
    style: {
      enableBackground: "new 0 0 213.3 70.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#XMLID_3_);}\n\t.st1{fill:#484E53;}\n\t.st2{fill:#808285;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.2417,
    y1: 33.2964,
    x2: 40.0876,
    y2: -5.0434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#10B857"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2105,
    style: {
      stopColor: "#11B868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3989,
    style: {
      stopColor: "#13B898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5779,
    style: {
      stopColor: "#15B7BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7428,
    style: {
      stopColor: "#17B7D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8886,
    style: {
      stopColor: "#18B7E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18B7EF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_179_",
    className: "st0",
    d: "M52.6,3.7L1.9,17.3l12.5,7.2l2.2,11.1l7-5.9L34,35.8L52.6,3.7z M38,10.4L15.6,22.1L9,18.2 L38,10.4z M18.3,30.6l-1.2-6.2l22.4-11.6l-17,14.3l0,0L18.3,30.6z M25.7,27.9l18.9-16L33,32.1L25.7,27.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_151_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    className: "st1",
    d: "M61.4,47.9v2.4c0,0.6-0.3,0.9-0.9,0.9h-2.7c-4.4,0-7.3-2.8-7.3-7.5V24.6 c0-0.6,0.3-0.9,0.9-0.9h2.3c0.6,0,0.9,0.3,0.9,0.9v5.7h6c0.5,0,0.8,0.3,0.8,0.8v2c0,0.5-0.3,0.8-0.8,0.8h-6v9.8 c0,1.8,1.4,3.2,3.3,3.2h2.6C61.1,47,61.4,47.3,61.4,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_170_",
    className: "st1",
    d: "M84.8,31.2v19c0,0.5-0.4,0.9-0.9,0.9h-1.8c-0.5,0-0.8-0.3-0.8-0.8v-1.8 c-1.9,1.8-4.4,2.9-7.2,2.9c-6,0-10.8-4.8-10.8-10.8c0-5.9,4.8-10.7,10.8-10.7c2.8,0,5.3,1.1,7.1,2.9v-1.7c0-0.5,0.4-0.8,0.9-0.8 h1.8C84.4,30.3,84.8,30.7,84.8,31.2z M80.7,40.7c0-3.6-2.9-6.5-6.6-6.5c-3.6,0-6.5,3-6.5,6.5c0,3.7,2.9,6.6,6.5,6.6 C77.8,47.3,80.7,44.4,80.7,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_168_",
    className: "st1",
    d: "M97.3,47.9v2.4c0,0.6-0.4,0.9-0.9,0.9H96c-4.3,0-6.7-2-6.7-7.1V22.9c0-0.6,0.3-0.9,0.9-0.9 h2.3c0.6,0,0.9,0.3,0.9,0.9v21.2c0,2,1.1,2.9,2.6,2.9h0.5C97,47,97.3,47.3,97.3,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_165_",
    className: "st1",
    d: "M119.2,42.1h-15.7c0.8,3.4,3.6,5.4,6.6,5.4c2.3,0,4.2-1,5.6-2.2c0.5-0.4,0.9-0.3,1.3,0.1 l1.3,1.6c0.4,0.5,0.4,0.9-0.1,1.3c-2.5,2.3-5.5,3.2-8.1,3.2c-6.3,0-10.9-5.2-10.9-11c0-6,4.7-10.5,10.5-10.5 c5.8,0,10.2,4.3,10.4,11.2C120.1,41.8,119.7,42.1,119.2,42.1z M115.7,38.8c-0.5-2.8-3-5.1-6.1-5.1c-3,0-5.6,2-6.2,5.1H115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_163_",
    className: "st1",
    d: "M141,38.8v11.4c0,0.6-0.3,0.9-0.9,0.9h-2.3c-0.6,0-0.9-0.3-0.9-0.9V38.8 c0-2.6-2.1-4.7-4.7-4.7c-2.6,0-4.7,2.1-4.7,4.7v11.4c0,0.6-0.4,0.9-0.9,0.9h-2.3c-0.6,0-0.9-0.3-0.9-0.9v-19 c0-0.6,0.3-0.9,0.9-0.9h1.7c0.5,0,0.8,0.3,0.8,0.8v0.9c1.5-1.3,3.5-2.1,5.6-2.1C137.1,30,141,34,141,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    className: "st1",
    d: "M156,47.9v2.4c0,0.6-0.3,0.9-0.9,0.9h-2.7c-4.4,0-7.3-2.8-7.3-7.5V24.6 c0-0.6,0.3-0.9,0.9-0.9h2.3c0.6,0,0.9,0.3,0.9,0.9v5.7h6c0.5,0,0.8,0.3,0.8,0.8v2c0,0.5-0.3,0.8-0.8,0.8h-6v9.8 c0,1.8,1.4,3.2,3.3,3.2h2.6C155.7,47,156,47.3,156,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_158_",
    className: "st1",
    d: "M164.8,26c0,1.5-1,2.5-2.6,2.5c-1.3,0-2.5-1-2.5-2.5c0-1.3,1.2-2.5,2.5-2.5 C163.8,23.5,164.8,24.7,164.8,26z M163.4,51.2h-2.3c-0.5,0-0.9-0.3-0.9-0.9v-19c0-0.6,0.4-0.9,0.9-0.9h2.3c0.6,0,0.9,0.3,0.9,0.9 v19C164.3,50.8,164,51.2,163.4,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_155_",
    className: "st1",
    d: "M178.7,51.5c-5.9,0-10.7-4.8-10.7-10.8c0-6,4.8-10.8,10.7-10.8c2.7,0,5.1,1,7,2.7 c0.5,0.4,0.5,0.8,0.1,1.3l-1.4,1.7c-0.4,0.5-0.8,0.5-1.3,0.1c-1.4-1.1-3-1.6-4.5-1.6c-3.6,0-6.5,3-6.5,6.5c0,3.6,3,6.6,6.5,6.6 c1.5,0,3-0.5,4.5-1.7c0.5-0.4,0.9-0.4,1.3,0.1l1.4,1.7c0.3,0.5,0.3,0.9-0.1,1.3C183.9,50.4,181.5,51.5,178.7,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_152_",
    className: "st1",
    d: "M209.4,31.2v19c0,0.5-0.4,0.9-0.9,0.9h-1.8c-0.5,0-0.8-0.3-0.8-0.8v-1.8 c-1.9,1.8-4.4,2.9-7.2,2.9c-6,0-10.8-4.8-10.8-10.8c0-5.9,4.8-10.7,10.8-10.7c2.8,0,5.3,1.1,7.1,2.9v-1.7c0-0.5,0.4-0.8,0.9-0.8 h1.8C209,30.3,209.4,30.7,209.4,31.2z M205.3,40.7c0-3.6-2.9-6.5-6.6-6.5c-3.6,0-6.5,3-6.5,6.5c0,3.7,2.9,6.6,6.5,6.6 C202.4,47.3,205.3,44.4,205.3,40.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_45_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_148_",
    className: "st2",
    d: "M56.8,63.3c0,2.5-1.4,3.8-3.8,3.8h-2.5v-7.7H53C55.4,59.5,56.8,60.9,56.8,63.3z M55.8,63.3 c0-1.9-1-3-2.8-3h-1.6v5.9h1.6C54.8,66.3,55.8,65.2,55.8,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_145_",
    className: "st2",
    d: "M62.6,64h-1.8v3.2h-0.9v-7.7h2.9c1.6,0,2.6,0.9,2.6,2.2c0,1.1-0.6,1.9-1.7,2.1l2.2,3.3h-1.1 L62.6,64z M60.8,63.1h2c1.1,0,1.6-0.5,1.6-1.4c0-0.9-0.5-1.4-1.6-1.4h-2V63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    className: "st2",
    d: "M74.1,66.3v0.9h-5.5v-7.7h5.4v0.9h-4.4v2.5H73v0.9h-3.5v2.6H74.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_140_",
    className: "st2",
    d: "M81.7,65h-3.5l-0.8,2.1h-1l3-7.7h1.1l3,7.7h-1L81.7,65z M81.4,64.2l-1-2.7L80,60.4h0l-0.3,1 l-1,2.7H81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    className: "st2",
    d: "M93.5,67.2h-0.9v-4.8l0.1-2h0l-2.5,6.8h-0.8l-2.5-6.8h0l0.1,2v4.8h-0.9v-7.7h1.4l1.7,4.6 l0.6,1.9h0l0.6-1.9l1.7-4.7h1.4V67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    className: "st2",
    d: "M106.6,59.5h2.7c1.8,0,2.6,0.8,2.6,2.1c0,0.8-0.5,1.5-1.3,1.6v0c0.9,0.2,1.5,0.9,1.5,1.7 c0,1.3-1,2.1-2.8,2.1h-2.7V59.5z M109.3,62.9c1.1,0,1.6-0.4,1.6-1.3c0-0.8-0.5-1.2-1.6-1.2h-1.8v2.5H109.3z M109.5,66.3 c1.1,0,1.6-0.5,1.6-1.3s-0.5-1.3-1.6-1.3h-2v2.6H109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_123_",
    className: "st2",
    d: "M121.1,64.3c0,2-1.1,3-3,3c-1.9,0-3-1-3-3v-4.8h0.9v4.6c0,1.6,0.6,2.3,2.1,2.3 s2.1-0.7,2.1-2.3v-4.6h0.9V64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    className: "st2",
    d: "M125.4,67.2h-0.9v-7.7h0.9V67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_118_",
    className: "st2",
    d: "M134.2,66.3v0.9h-5.3v-7.7h0.9v6.8H134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    className: "st2",
    d: "M143.2,63.3c0,2.5-1.4,3.8-3.8,3.8h-2.5v-7.7h2.5C141.8,59.5,143.2,60.9,143.2,63.3z  M142.2,63.3c0-1.9-1-3-2.8-3h-1.6v5.9h1.6C141.2,66.3,142.2,65.2,142.2,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_93_",
    className: "st2",
    d: "M161.7,63.3c0,2.5-1.4,3.8-3.8,3.8h-2.5v-7.7h2.5C160.3,59.5,161.7,60.9,161.7,63.3z  M160.8,63.3c0-1.9-1-3-2.8-3h-1.6v5.9h1.6C159.7,66.3,160.8,65.2,160.8,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    className: "st2",
    d: "M165.7,67.2h-0.9v-7.7h0.9V67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    className: "st2",
    d: "M174.7,61l-0.8,0.6c-0.5-1-1-1.4-2.1-1.4c-1.2,0-1.9,0.6-1.9,1.3c0,0.7,0.5,1.1,2.1,1.4 c2.1,0.3,2.8,1,2.8,2.2c0,1.3-1.2,2.2-3,2.2c-1.6,0-2.7-0.7-3.2-1.7l0.8-0.6c0.4,0.9,1.2,1.4,2.4,1.4c1.2,0,2-0.4,2-1.3 c0-0.7-0.5-1-2.1-1.3c-2.1-0.4-2.8-1-2.8-2.2c0-1.2,1.1-2.3,2.9-2.3C173.1,59.4,174.1,59.9,174.7,61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    className: "st2",
    d: "M180.5,64h-1.8v3.2h-0.9v-7.7h2.9c1.6,0,2.6,0.9,2.6,2.2c0,1.1-0.6,1.9-1.7,2.1l2.2,3.3h-1.1 L180.5,64z M178.7,63.1h2c1.1,0,1.6-0.5,1.6-1.4c0-0.9-0.5-1.4-1.6-1.4h-2V63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    className: "st2",
    d: "M192.3,64.3c0,2-1.1,3-3,3c-1.9,0-3-1-3-3v-4.8h0.9v4.6c0,1.6,0.6,2.3,2.1,2.3 c1.4,0,2.1-0.7,2.1-2.3v-4.6h0.9V64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st2",
    d: "M201,61.8c0,1.4-1,2.3-2.6,2.3h-1.8v3h-0.9v-7.7h2.7C200,59.5,201,60.4,201,61.8z M200,61.8 c0-1-0.5-1.5-1.7-1.5h-1.6v2.9h1.6C199.5,63.3,200,62.8,200,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st2",
    d: "M209.4,60.4h-2.7v6.8h-0.9v-6.8h-2.7v-0.9h6.3V60.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_47_",
    className: "st2",
    cx: 100.1,
    cy: 63.5,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_46_",
    className: "st2",
    cx: 148.9,
    cy: 63.5,
    r: 0.7
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalenticaLogo);
export default __webpack_public_path__ + "static/media/talentica_logo.0fba52da55da9efe02953dc28393ed93.svg";
export { ForwardRef as ReactComponent };